import { gql } from 'apollo-angular';

export const PROFILE_QUERY = gql`
  query UserProfile {
    userProfile {
      data {
        firstName
        lastName
        country
        countryCode
        region
        email
        phone
        communicationLanguage
        jobTitle
        title
        oscContactId
        portalLanguage
        veracityId
        accessType
        accessLevel {
          roleLevel
          roleName
        }
      }
      isSuccess
      message
      errorCode
    }
  }
`;
